<template>
  <v-app class="bd-app">
    <v-main :class="isLogin() ? 'bd-app-login' : 'bd-app-home'">
      <Header :key="$route.path" />
      <div class="header-background" />
      <router-view :key="'view' + $route.path"></router-view>
      <div class="footer-spacer" />
      <Footer />
    </v-main>
  </v-app>
</template>

<script>
import Header from '@/components/Header'
import Footer from '@/components/Footer'

export default {
  components: { Header, Footer },
  methods: {
    isLogin() {
      return this.$route.fullPath.includes('/login')
    }
  }
}
</script>

<style lang="scss">
@import './styles/global.scss';

.bd-app {
  min-width: 320px;
  height: 100%;

  .v-application--wrap {
    min-height: 100%;
  }
  .footer-spacer {
    height: 80px;
  }
  .bd-app-login {
    background-image: url('~@/assets/img/background.jpg');
    background-position: left;
    background-repeat: no-repeat;
    background-size: cover;
  }
  .bd-app-home {
    .header {
      position: absolute;
      width: 100%;
    }
    .header-background {
      background-image: url('~@/assets/img/background-app-mobile.png');
      background-repeat: no-repeat;
      background-position: left top;
      background-size: cover;
      height: 168px;

      @media only screen and (min-width: 600px) {
        background-image: url('~@/assets/img/background-app.png');
        background-position: top;
        height: 29%;
      }
    }
  }
}
</style>
